module.exports = __webpack_public_path__ + "img/edit-new.be48a108.svg";